﻿import { SerializableObject } from '../../common-react/core';

export enum DimensionUnit {
  CM = 'CM'
}

export enum WeightUnit {
  KG = 'KG',
  G = 'G'
}

export class Parcel extends SerializableObject {
  // The units used for dimension description (width,height,length).
  public dimensionUnit?: DimensionUnit;

  // The units used for weight description.
  public weightUnit?: WeightUnit;

  // Weight of parcel
  public weight?: number;

  // Width of parcel
  public width?: number;

  // Height of parcel
  public height?: number;

  // Length of parcel
  public length?: number;

  // The shipment id the parcel belongs to
  public shipmentId?: string;
}
